import { useDictionary } from '@/core/providers/dictionary-provider';

/** Breadcrumb for Reputation subpages: "Reputation / <page>". */
export function ReputationPageBreadcrumb({ pageLabel }: { pageLabel: string }) {
  const dict = useDictionary();
  return (
    <>
      {dict.nav.reputation}
      <span className="mx-1.5 text-muted-foreground/70">/</span>
      {pageLabel}
    </>
  );
}
